export enum BlockType {
    User
}